import SummaryCard from 'components/SummaryCard';
import React from 'react';
import { Badge } from 'reactstrap';

interface PCFindingData {
  policy_title: string;
  control_statement: string;
  control_cid: string;
  control_criticality_label: string;
  status: string;
  host_name: string;
  host_alias?: string;
  evaluation_date: string;
}

interface PCFindingSummaryCardProps {
  rowData: any;
}

const statusMap: Record<
  string,
  { label: string; color: string; icon: string }
> = {
  Passed: { label: 'Passed', color: 'success', icon: 'fa-check-circle' },
  Failed: { label: 'Failed', color: 'danger', icon: 'fa-times-circle' },
  Exception: {
    label: 'Exception',
    color: 'warning',
    icon: 'fa-question-circle',
  },
  Error: { label: 'Error', color: 'danger', icon: 'fa-exclamation-circle' },
};

const PCFindingSummaryCard: React.FC<PCFindingSummaryCardProps> = ({
  rowData,
}) => {
  const data = rowData as PCFindingData;
  const hostName = `${data.host_name} ${
    data.host_alias ? `(${data.host_alias})` : ''
  }`;

  // Prepare summary data
  const summaryData = [
    { key: 'CID', value: data.control_cid },
    { key: 'Policy', value: data.policy_title },
    { key: 'Host', value: hostName },
    { key: 'Criticality', value: data.control_criticality_label },
    { key: 'Last Evaluated', value: data.evaluation_date },
  ];

  // Status badge for heading
  const getStatusBadge = () => {
    const { color, label } = statusMap[data.status] || {
      color: 'secondary',
      label: data.status,
    };
    return (
      <Badge color={color} pill className="ml-2">
        {label}
      </Badge>
    );
  };

  return (
    <SummaryCard
      heading={
        <div className="d-flex align-items-center flex-wrap">
          <span style={{ fontWeight: 600 }}>
            {data.control_statement.trim()}
            {getStatusBadge()}
          </span>
        </div>
      }
      data={summaryData}
      icon={
        <i
          className={`fa ${statusMap[data.status]?.icon || 'fa-shield-alt'} ${
            `text-${statusMap[data.status]?.color}` || ''
          }`}
          aria-hidden="true"
          style={{ fontSize: '2.5rem' }}
        />
      }
      mode="normal"
    />
  );
};

export default PCFindingSummaryCard;
